import { getApiClient } from "./ApiClient.js";


/**
 * Holt Bankdaten anhand der IBAN.
 * @param {string} iban - Die IBAN
 * @returns {Promise<{status: number, data: object}>}
 */
export function getBankname(iban) {
    const client = getApiClient();
    return client.get(`/api/v1/bank_by_iban/${iban}`);
}
